import { useId } from "react";
import { Form } from "react-bootstrap";
export function Field({
  label,
  value,
  onChange,
  options,
  type = "text",
  required = false,
  placeholder,
  name,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  options?: string[];
  type?: string;
  required?: boolean;
  placeholder?: string;
  name?: string;
}) {
  const id = useId();
  return (
    <Form.Group className="mb-3" controlId={id}>
      <Form.Label>{label}</Form.Label>
      {options ? (
        <Form.Select name={name} value={value} onChange={(e) => onChange(e.target.value)}>
          {options.map((o) => (
            <option key={o}>{o}</option>
          ))}
        </Form.Select>
      ) : (
        <Form.Control
          as={type === "textarea" ? "textarea" : "input"}
          type={type === "textarea" ? undefined : type}
          name={name}
          value={value}
          required={required}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </Form.Group>
  );
}
